module.exports = __webpack_public_path__ + "src/img/sigfloSymbolLogo.fe538c5f.svg";